/**
 * @module: 发布职位模块
 * @author: xiongsha
 * @date: 2019-11-12 14:03:08
 */
import { observable, action, flow } from 'mobx';
import { Toast } from 'antd-mobile';
import { ajax } from '@clouderwork/ywk';
import { IPosition, ISkills } from '@src/entity/zhaopin/position';
import { withRole } from '@src/utils/residentNew';
interface ILabels {
  id: string;
  name: string;
}

class Position {
  //工作地点抽屉
  @observable
  workDrawer: boolean = false;
  //联系人抽屉
  @observable
  linkDrawer: boolean = false;
  //职能描述抽屉
  @observable
  descDrawer: boolean = false;
  //职能分类抽屉
  @observable
  sortDrawer: boolean = false;
  //技能要求抽屉
  @observable
  skillDrawer: boolean = false;
  //职位亮点抽屉
  @observable
  pointDrawer: boolean = false;
  // 发布职位公司信息弹出框
  @observable
  companyDrawer: boolean = false;
  // 发布职位校验弹窗
  @observable
  verifyModal: boolean = false;
  //附件上传抽屉
  @observable
  uploadDrawer: boolean = false;
  // 技能要求数据
  @observable
  skills: ISkills[] = [];
  @observable
  points: any[] = []; // 职位亮点
  // 自定义标签组
  @observable
  customTags: string[] = [];
  // 自定义亮点标签组
  @observable
  customPointTags: ILabels[] = [];
  // 发布职位字段
  @observable
  positionData: IPosition = {
    description: '',
    contact: '',
    contract_phone: '',
    contract_email: '',
    soreText: '',
    job_title: [],
    location: [0, 0], // 地点id
    address: '', //详细地址
    locationKey: '',
    skills: [],
    sortId: 0,
    job_industry: 0,
    attachment: [],
    attachmentName: '',
    tech: 0,
    points: [
      { id: 2, name: '五险一金' },
      { id: 5, name: '绩效奖金' }
    ]
  };
  @observable
  fetchState: string = 'init';
  // 修改抽屉状态
  @action.bound
  changeDrawer = (name: string, val: boolean) => {
    this[name] = val;
  };
  // 修改发布职位里面字段
  setPosition = val => {
    this.positionData = { ...this.positionData, ...val };
  };
  @action.bound
  /**
   * @param {number} 查询对应职能下默认标签
   */
  async getSkill(tech_id: number) {
    const res = await ajax.getJson('/zhaopin/api/skills/new', withRole({ tech_id }));
    if (res.error_code === 0) {
      this.skills = res.skills;
    }
  }

  @action.bound
  /**
   * 后付费验证码
   */
  async sendCode(phone: string, vtype = 'resident_post_payment_offer') {
    // @ts-ignore
    return await ajax.postJson(`${PASSPORT_DOMAIN}/api/v2/verifycode`, { phone, vtype });
  }
  @action.bound
  /**
   * 后付费验证码验证
   */
  async checkCode(username: string, vcode: string, vtype = 'resident_post_payment_offer') {
    // @ts-ignore
    return await ajax.postJson(`${PASSPORT_DOMAIN}/api/v2/verifycode/check`, { username, vtype, vcode });
  }

  /**
   * 发布or 编辑职位
   */
  @action.bound
  async createOrEdit(method: (url: any, data?: {} | undefined, options?: any) => Promise<any>, url: string, data) {
    if (this.fetchState === 'pending') return;
    this.fetchState = 'pending';
    const res = await method(url, data);
    this.fetchState = 'done';
    return res;
  }
}
export default Position;
